const config = {
    apiKey: "AIzaSyB2BxGt50ie2Uwu4d2MQ_pN48aiNBhWVOM",
    authDomain: "tapajyoti-bose.firebaseapp.com",
    databaseURL: "https://tapajyoti-bose-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "tapajyoti-bose",
    storageBucket: "tapajyoti-bose.appspot.com",
    messagingSenderId: "1040066915816",
    appId: "1:1040066915816:web:827b80d148e9afa713085d",
    measurementId: "G-HGGMDGPNPG"
};

export default config